import { LineChart } from "lucide-react";

export function AnalyticsIcon({ className }: { className?: string }) {
  return <LineChart className={className} strokeWidth={1.5} />;
}
